export default __webpack_public_path__ + "static/media/dtal-insieme.f863999c.png";